<template>
  <div
    :class="['relative', positionBadge === 'pricebox' ? 'dib': '']"
    @mouseover="handleMouseover"
    @mouseleave="showToolTip = false"
  >
    <div v-if="positionBadge === 'pricebox'" class="inline-flex items-center wp-100 justify-center pt-6">
      <img class="h-14" :src="`${ASSETS_CDN}/icons/icon-deal.png`" alt="This is a free cancellation trip"/>
      <span class="fs-12 lh-20 fw-500 pl-8">{{ badgeName }}</span>
    </div>
    <div v-else :class="['inline-flex items-center h-24 pl-8 pr-8 br-5',badgeColor]">
      <template v-if="typeBadge === 'custom'">
<!--        <div v-if="positionBadge === 'pricebox'" class="flex items-center wp-100 justify-center pt-6">-->
<!--          <img class="h-14" :src="`${ASSETS_CDN}/icons/icon-deal.png`" alt="This is a free cancellation trip"/>-->
<!--          <span class="fs-12 lh-20 fw-500 pl-8">{{ badgeName }}</span>-->
<!--        </div>-->
        <div class="flex mr-8 flex-shrink-0">
          <img src="https://s3-cdn.designerjourneys.com/static/icons/deal.png" width='16' height='16' alt="special deal"/>
        </div>
        <span class="card-item-title fw-600 fs-11 black italic dib lh-13">{{ badgeName }}</span>
      </template>
      <template v-else-if="typeBadge === 'flights'">
        <div class="flex mr-8 flex-shrink-0">
          <img src="https://s3-cdn.designerjourneys.com/static/vectors/general/card-features-1.svg" />
        </div>
        <span class="card-item-title fw-600 fs-11 black italic dib lh-13"
          >Free flights</span
        >
      </template>
      <template v-else>
        <div class="flex mr-5 flex-shrink-0">
          <img height="16" width="16" src="https://s3-cdn.designerjourneys.com/static/icons/deal.png" />
        </div>
        <span class="card-item-title fw-600 fs-11 black italic dib lh-20"
          >Free Cancellation*</span
        >
      </template>
    </div>
    <transition name="tooltip-fade">
      <ToolTip
        v-if="showToolTip && tooltipText !== ''"
        :content="tooltipText"
        :customClass="tooltipCustomClass"
        @clickTooltip="onClickTooltip"
      ></ToolTip>
    </transition>
  </div>
</template>

<script>
import ToolTip from '~/components/ui/tooltip/ToolTip'
import { ref, computed } from 'vue'
import {assetCDN} from '~/helper'

export default {
  name: 'Badge',
  components: { ToolTip },
  props: {
    badgeColor: { type: String, default: 'bg-green' },
    typeBadge: { type: String, default: null },
    badgeName: { type: String, default: null },
    tooltipText: { type: String, default: '' },
    positionBadge: { type: String, default: '' },
    tooltipDisable: { type: Boolean, default: false },
  },
  setup(props, {emit}) {
    const showToolTip = ref(false)
    const ASSETS_CDN = assetCDN()

    const handleMouseover = () => {
      if (!props.tooltipDisable && props.tooltipText) {
        showToolTip.value = true
      }
    }

    const onClickTooltip = () =>{
      emit('ClickTooltip')
    }

    const tooltipCustomClass = computed(() => {
      if(props.positionBadge === 'pricebox') return 'tooltip-bottom-left left-0 pt-8 w-181 overflow-visible'
      return 'tooltip-bottom-left left-0 pt-8 w-181'
    })

    return { handleMouseover, showToolTip, onClickTooltip, ASSETS_CDN, tooltipCustomClass }
  },
}
</script>

<style scoped></style>
